var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center"},[_vm._v("Excel")]),_c('input',{attrs:{"id":"archivoExcel","type":"file"},on:{"change":function($event){return _vm.subirExcel()}}}),_c('v-card',{staticStyle:{"margin-top":"20px"}},[(_vm.Items.length > 0)?_c('tabla',{attrs:{"Titulo":"Productos","Cabecera":_vm.Cabecera,"Items":_vm.Items}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }